import React, { useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./styles/theme";
import { CssBaseline, Box } from "@mui/material";
import Header from "./components/Header";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
// Import pages
import MainPage from "./pages/MainPage";
import AccountPage from "./pages/AccountPage";
import LogoutPage from "./pages/LogoutPage";
import HatDetailPage from "./pages/HatDetailPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import StylePage from "./pages/StylePage";
import AccountSetupPage from "./pages/AccountSetupPage";

function App() {
  const [bag, setBag] = useState([]);

  const addToBag = (hat, quantity, color) => {
    setBag((prevBag) => [...prevBag, { ...hat, quantity, color }]);
  };

  const removeFromBag = (index) => {
    setBag(bag.filter((_, i) => i !== index));
  };

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
            }}
          >
            <Header bag={bag} removeFromBag={removeFromBag} />
            <Box sx={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/styles" element={<StylePage />} />
                <Route path="/accountsetup" element={<AccountSetupPage />} />

                <Route
                  path="/main"
                  element={
                    <ProtectedRoute>
                      <MainPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/account"
                  element={
                    <ProtectedRoute>
                      <AccountPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/logout" element={<LogoutPage />} />
                <Route
                  path="/hat/:id"
                  element={
                    <ProtectedRoute>
                      <HatDetailPage addToBag={addToBag} />
                    </ProtectedRoute>
                  }
                />
                <Route path="/about-us" element={<AboutUsPage />} />
                <Route path="/contact-us" element={<ContactUsPage />} />
                <Route path="/login" element={<LoginPage />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  return children;
};

export default App;